<template>
  <div class="bg-gray">
    <navigation-bar />
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12" style="padding-top:20px;">
          <div class="row">
            <div class="col-sm-12 text-center" style="margin-top:50px;">
              <h3>Your Listing Is Live!</h3>
              <p>Thank you for posting a listing, it is now live!</p>
              <router-link to="/account/listing/create">
                <button style="height:50px;width:200px;" class="btn btn-primary btn-blue">Create Another Listing</button>
              </router-link>
              <br><br>
            </div>
          </div>
        </div>
        <br />
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from "../nav/NavigationBar";
import DashboardFooter from "../nav/Footer";
import Utils from "@/Utils/Utils";
import Navigator from "@/router/navigator";
import AccountSessionUtils from "./AccountSessionUtils";
import API from "@/API/API";

export default {
  name: "ListingSuccess",
  components: {
    NavigationBar,
    DashboardFooter
  },
  data() {
    return {
      nav: Navigator,
      accountUtils: AccountSessionUtils,
      utils: Utils
    };
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/account/ListingSuccess.vue